export const PmdLoaderMetadata = {
    name: "pmd",
    extensions: {
        // eslint-disable-next-line @typescript-eslint/naming-convention
        ".pmd": { isBinary: true }
    }
};
